export default __webpack_public_path__ + "static/media/workflowdiagram-02-min.b1fd244e.png";